/* BUSINESS PERFORMANCE — the Inventory and Marketing pages (tables, 2026-10-24). Codes (HINC, HUSA, SKU, USD, ROAS, CTR,
   CPC, CPM, MER, GA4) stay as they are in every language. */
const en = {
  reportInventory: 'Inventory Page',
  reportMarketing: 'Marketing Page',
  reportPole: 'Pole Inventory Page',
  poleTitle: 'Pole-based products — current position',
  poleSubPage: 'Snapshot {{d}} · stock at the end of {{m}}, received and sold from {{f}} (sales through {{s}}), today\'s stock read from SAP and NetSuite, open purchase orders by the month they are due.',
  poleBase: 'base {{m}}',
  poleEmpty: 'No Current position snapshot yet — Global Pole Inventory takes one every morning.',
  poleReceived: 'Received since',
  poleToGroup: 'To other Helinox entities',
  poleOther: 'Other movements',
  poleMosTile: 'Months of stock · incl. PO',
  poleNote: 'Other movements = what received and sold do not explain (a Costco 2-pack, adjustments, transfers). HINC leaves out its factory POs for HUSA / HEMA / HPAC goods ({{q}} pcs) — those entities\' own POs count them. Months of stock = stock ÷ the average month of the three to {{m}}; under 2 is marked.',
  family: 'Family',
  chStock: 'Stock and open PO by entity',
  chPoMonth: 'Open PO by month due',
  chTopFam: 'Top 12 families by stock today',
  chMos: 'Months of stock by entity',
  secPoleFamily: 'By entity and family',
  secPoleByFam: 'By family across entities',
  poOverdue: 'Overdue',
  poNoDate: 'No date',
  expandAll: 'Expand all',
  collapseAll: 'Collapse all',
  exportXlsx: 'Export Excel',
  exportHtml: 'Export HTML',
  shareLink: 'Share link',
  shareTitle: 'HTML link — always the latest snapshot',
  shareSub: 'Opens this page with no portal sign-in. It always shows the latest morning snapshot, and another day can be picked on it.',
  shareWarn: 'Anyone who has the link can read every figure on it (quantities by entity and family, no prices). Send it only inside the company. Replace it to stop the old link working.',
  noLink: 'There is no link yet.',
  makeLink: 'Make the link',
  replaceLink: 'Replace the link',
  switchOff: 'Switch the link off',
  copy: 'Copy',
  copied: 'Copied',
  open: 'Open',
  close: 'Close',
  day: 'Snapshot day',
  friday: 'Friday',
  vsDay: 'compared with {{d}}',
  month: 'Month',
  currency: 'Currency',
  reload: 'Refresh',
  loading: 'Loading…',
  noData: 'No figures for this choice.',
  total: 'TOTAL',
  invTitle: 'Inventory Page',
  invSub: 'Stock on hand on {{d}} (all six entities in), in USD, against {{p}}. A snapshot is a stock: days are never added together.',
  secEntity: 'By entity',
  secCategory: 'By category',
  secOldest: 'Oldest stock — top 20 SKUs by value over 1 year',
  secPole: 'Frames — current position',
  poleSub: 'Snapshot {{d}} · stock from the end of {{m}} moved by what was received and sold since',
  entity: 'Entity',
  category: 'Category',
  notClassified: 'Not classified yet',
  qty: 'Qty',
  usd: 'Amount (USD)',
  chgUsd: 'Δ vs last week',
  chgPct: 'Δ %',
  share: '% Mix',
  transitQty: 'In transit qty',
  transitUsd: 'In transit (USD)',
  b90: '< 90 days',
  b180: '90–180 days',
  b365: '180 days–1 year',
  b1y: 'Over 1 year',
  over1yPct: '% over 1 year',
  skus: 'SKUs',
  avgAge: 'Avg age (days)',
  sku: 'SKU',
  product: 'Product',
  color: 'Color',
  endQty: 'End {{m}}',
  nowQty: 'Stock today',
  sold: 'Sold since',
  avgMonth: 'Avg sales / month',
  mos: 'Months of stock',
  openPo: 'Open PO',
  mosPo: 'Months incl. PO',
  mktTitle: 'Marketing Page',
  mktSub: '{{m}} in {{c}}{{through}} · compared with {{p}} and {{ly}} over the same days',
  through: ', through {{d}}',
  secMarket: 'By market',
  secPlatform: 'By platform',
  secCampaign: 'Campaigns that spent most — top 20',
  market: 'Market',
  channel: 'Channel',
  platform: 'Platform',
  campaign: 'Campaign',
  spend: 'Ad spend',
  spendMoM: 'Spend vs last month',
  impressions: 'Impressions',
  clicks: 'Clicks',
  ctr: 'CTR',
  cpc: 'CPC',
  cpm: 'CPM',
  attrRev: 'Claimed revenue',
  attrOrders: 'Claimed orders',
  roas: 'ROAS',
  roasHint: 'Revenue the ad platforms claim ÷ the spend of the platforms that claim one (Meta, Amazon). Google Ads reports none here.',
  emailRev: 'Email revenue',
  sessions: 'Sessions',
  webConv: 'Web conversion',
  storeRev: 'Store sales',
  storeMoM: 'Sales vs last month',
  storeLy: 'Sales vs last year',
  mer: 'Sales / spend',
  merHint: 'Store sales ÷ ad spend in the same market (marketing efficiency ratio). Counts every sale, not only the ones an ad claims.',
  noteMkt: 'Store sales are the online stores (Shopify). Claimed revenue is what Meta and Amazon attribute to their own ads — the two are not added together.',
};

const ko = {
  reportInventory: '재고 페이지',
  reportMarketing: '마케팅 페이지',
  reportPole: '폴 재고 페이지',
  poleTitle: '폴 기반 제품 — 현재 현황',
  poleSubPage: '스냅샷 {{d}} · {{m}} 말 재고, {{f}}부터의 입고·판매(판매는 {{s}}까지), SAP·NetSuite에서 읽은 현재 재고, 입고 예정 월별 미입고 PO.',
  poleBase: '기준 {{m}}',
  poleEmpty: '아직 현재 현황 스냅샷이 없습니다 — Global Pole Inventory가 매일 아침 생성합니다.',
  poleReceived: '이후 입고',
  poleToGroup: '타 Helinox 법인 출고',
  poleOther: '기타 변동',
  poleMosTile: '재고 개월수 · PO 포함',
  poleNote: '기타 변동 = 입고·판매로 설명되지 않는 변동(Costco 2-pack, 조정, 이동). HINC는 HUSA / HEMA / HPAC 상품용 공장 PO({{q}} pcs)를 제외합니다 — 각 법인의 PO에서 집계됩니다. 재고 개월수 = 재고 ÷ {{m}}까지 3개월 월평균 판매; 2 미만은 표시됩니다.',
  family: '패밀리',
  chStock: '법인별 재고와 미입고 PO',
  chPoMonth: '입고 예정 월별 미입고 PO',
  chTopFam: '현재 재고 상위 12개 패밀리',
  chMos: '법인별 재고 개월수',
  secPoleFamily: '법인 및 패밀리별',
  secPoleByFam: '패밀리별 (법인 비교)',
  poOverdue: '지연',
  poNoDate: '일자 없음',
  expandAll: '모두 펼치기',
  collapseAll: '모두 접기',
  exportXlsx: 'Excel 내보내기',
  exportHtml: 'HTML 내보내기',
  shareLink: '공유 링크',
  shareTitle: 'HTML 링크 — 항상 최신 스냅샷',
  shareSub: '포털 로그인 없이 이 페이지를 엽니다. 항상 최신 아침 스냅샷을 보여주며, 페이지에서 다른 날짜를 선택할 수 있습니다.',
  shareWarn: '링크를 가진 사람은 누구나 모든 수치(법인·패밀리별 수량, 가격 없음)를 볼 수 있습니다. 사내에만 보내세요. 기존 링크를 막으려면 링크를 교체하세요.',
  noLink: '아직 링크가 없습니다.',
  makeLink: '링크 만들기',
  replaceLink: '링크 교체',
  switchOff: '링크 끄기',
  copy: '복사',
  copied: '복사됨',
  open: '열기',
  close: '닫기',
  day: '스냅샷 날짜',
  friday: '금요일',
  vsDay: '{{d}} 대비',
  month: '월',
  currency: '통화',
  reload: '새로고침',
  loading: '불러오는 중…',
  noData: '이 선택에 해당하는 수치가 없습니다.',
  total: '합계',
  invTitle: '재고 페이지',
  invSub: '{{d}} 보유 재고(6개 법인 모두 반영), USD 기준, {{p}} 대비. 스냅샷은 재고이므로 날짜끼리 더하지 않습니다.',
  secEntity: '법인별',
  secCategory: '카테고리별',
  secOldest: '장기 재고 — 1년 초과 금액 상위 20개 SKU',
  secPole: '프레임 — 현재 현황',
  poleSub: '스냅샷 {{d}} · {{m}} 말 재고에 이후 입고·판매를 반영',
  entity: '법인',
  category: '카테고리',
  notClassified: '미분류',
  qty: '수량',
  usd: '금액 (USD)',
  chgUsd: '전주 대비 Δ',
  chgPct: 'Δ %',
  share: '% 비중',
  transitQty: '운송 중 수량',
  transitUsd: '운송 중 (USD)',
  b90: '90일 미만',
  b180: '90–180일',
  b365: '180일–1년',
  b1y: '1년 초과',
  over1yPct: '1년 초과 %',
  skus: 'SKU 수',
  avgAge: '평균 재고일수',
  sku: 'SKU',
  product: '제품',
  color: '색상',
  endQty: '{{m}} 말',
  nowQty: '현재 재고',
  sold: '이후 판매',
  avgMonth: '월평균 판매',
  mos: '재고 개월수',
  openPo: '미입고 PO',
  mosPo: 'PO 포함 개월수',
  mktTitle: '마케팅 페이지',
  mktSub: '{{m}}, {{c}}{{through}} · 같은 기간의 {{p}}, {{ly}} 대비',
  through: ', {{d}}까지',
  secMarket: '시장별',
  secPlatform: '플랫폼별',
  secCampaign: '지출 상위 캠페인 — 20개',
  market: '시장',
  channel: '채널',
  platform: '플랫폼',
  campaign: '캠페인',
  spend: '광고비',
  spendMoM: '광고비 전월 대비',
  impressions: '노출',
  clicks: '클릭',
  ctr: 'CTR',
  cpc: 'CPC',
  cpm: 'CPM',
  attrRev: '광고 기여 매출',
  attrOrders: '광고 기여 주문',
  roas: 'ROAS',
  roasHint: '광고 플랫폼이 주장하는 매출 ÷ 그런 매출을 보고하는 플랫폼(Meta, Amazon)의 광고비. Google Ads는 여기서 보고하지 않습니다.',
  emailRev: '이메일 매출',
  sessions: '세션',
  webConv: '웹 전환율',
  storeRev: '스토어 매출',
  storeMoM: '매출 전월 대비',
  storeLy: '매출 전년 대비',
  mer: '매출 / 광고비',
  merHint: '같은 시장의 스토어 매출 ÷ 광고비(마케팅 효율 지표). 광고 기여분만이 아닌 전체 매출 기준입니다.',
  noteMkt: '스토어 매출은 온라인 스토어(Shopify) 기준입니다. 광고 기여 매출은 Meta와 Amazon이 자사 광고에 귀속한 매출이며, 두 수치는 더하지 않습니다.',
};

const vi = {
  reportInventory: 'Trang tồn kho',
  reportMarketing: 'Trang marketing',
  reportPole: 'Trang tồn kho khung (pole)',
  poleTitle: 'Sản phẩm dùng khung — vị trí hiện tại',
  poleSubPage: 'Chụp ngày {{d}} · tồn cuối {{m}}, hàng nhập và bán từ {{f}} (doanh số đến {{s}}), tồn hôm nay đọc từ SAP và NetSuite, PO chưa nhận theo tháng dự kiến.',
  poleBase: 'gốc {{m}}',
  poleEmpty: 'Chưa có ảnh chụp Current position — Global Pole Inventory chụp mỗi sáng.',
  poleReceived: 'Đã nhập từ đó',
  poleToGroup: 'Chuyển cho entity Helinox khác',
  poleOther: 'Biến động khác',
  poleMosTile: 'Số tháng tồn · gồm PO',
  poleNote: 'Biến động khác = phần nhập và bán không giải thích được (Costco 2-pack, điều chỉnh, chuyển kho). HINC bỏ PO nhà máy cho hàng của HUSA / HEMA / HPAC ({{q}} pcs) — đã tính trong PO của các entity đó. Số tháng tồn = tồn ÷ bán trung bình tháng của 3 tháng đến {{m}}; dưới 2 được đánh dấu.',
  family: 'Dòng',
  chStock: 'Tồn và PO chưa nhận theo entity',
  chPoMonth: 'PO chưa nhận theo tháng dự kiến',
  chTopFam: '12 dòng tồn nhiều nhất hôm nay',
  chMos: 'Số tháng tồn theo entity',
  secPoleFamily: 'Theo entity và dòng',
  secPoleByFam: 'Theo dòng, so các entity',
  poOverdue: 'Quá hạn',
  poNoDate: 'Không có ngày',
  expandAll: 'Mở tất cả',
  collapseAll: 'Thu gọn',
  exportXlsx: 'Xuất Excel',
  exportHtml: 'Xuất HTML',
  shareLink: 'Link chia sẻ',
  shareTitle: 'Link HTML — luôn là ảnh chụp mới nhất',
  shareSub: 'Mở trang này không cần đăng nhập portal. Luôn hiện ảnh chụp buổi sáng mới nhất, và chọn được ngày khác ngay trên trang.',
  shareWarn: 'Ai có link cũng đọc được mọi số liệu trên đó (số lượng theo entity và dòng, không có giá). Chỉ gửi trong công ty. Thay link để link cũ hết hiệu lực.',
  noLink: 'Chưa có link.',
  makeLink: 'Tạo link',
  replaceLink: 'Thay link',
  switchOff: 'Tắt link',
  copy: 'Sao chép',
  copied: 'Đã sao chép',
  open: 'Mở',
  close: 'Đóng',
  day: 'Ngày chụp',
  friday: 'Thứ Sáu',
  vsDay: 'so với {{d}}',
  month: 'Tháng',
  currency: 'Tiền tệ',
  reload: 'Làm mới',
  loading: 'Đang tải…',
  noData: 'Không có số liệu cho lựa chọn này.',
  total: 'TỔNG',
  invTitle: 'Trang tồn kho',
  invSub: 'Tồn kho ngày {{d}} (đủ sáu entity), tính bằng USD, so với {{p}}. Một ngày chụp là số tồn: không cộng các ngày với nhau.',
  secEntity: 'Theo entity',
  secCategory: 'Theo nhóm hàng',
  secOldest: 'Hàng tồn lâu — 20 SKU có giá trị trên 1 năm lớn nhất',
  secPole: 'Khung — vị trí hiện tại',
  poleSub: 'Chụp ngày {{d}} · tồn cuối {{m}} cộng hàng đã nhập, trừ hàng đã bán từ đó',
  entity: 'Entity',
  category: 'Nhóm hàng',
  notClassified: 'Chưa phân loại',
  qty: 'SL',
  usd: 'Giá trị (USD)',
  chgUsd: 'Δ so tuần trước',
  chgPct: 'Δ %',
  share: '% Tỷ trọng',
  transitQty: 'SL đang về',
  transitUsd: 'Đang về (USD)',
  b90: '< 90 ngày',
  b180: '90–180 ngày',
  b365: '180 ngày–1 năm',
  b1y: 'Trên 1 năm',
  over1yPct: '% trên 1 năm',
  skus: 'Số SKU',
  avgAge: 'Tuổi TB (ngày)',
  sku: 'SKU',
  product: 'Sản phẩm',
  color: 'Màu',
  endQty: 'Cuối {{m}}',
  nowQty: 'Tồn hôm nay',
  sold: 'Đã bán từ đó',
  avgMonth: 'Bán TB / tháng',
  mos: 'Số tháng tồn',
  openPo: 'PO chưa nhận',
  mosPo: 'Số tháng gồm PO',
  mktTitle: 'Trang marketing',
  mktSub: '{{m}} bằng {{c}}{{through}} · so với {{p}} và {{ly}} cùng số ngày',
  through: ', đến {{d}}',
  secMarket: 'Theo thị trường',
  secPlatform: 'Theo nền tảng',
  secCampaign: 'Chiến dịch chi nhiều nhất — 20 chiến dịch',
  market: 'Thị trường',
  channel: 'Kênh',
  platform: 'Nền tảng',
  campaign: 'Chiến dịch',
  spend: 'Chi phí QC',
  spendMoM: 'Chi phí so tháng trước',
  impressions: 'Lượt hiển thị',
  clicks: 'Lượt nhấp',
  ctr: 'CTR',
  cpc: 'CPC',
  cpm: 'CPM',
  attrRev: 'Doanh thu QC ghi nhận',
  attrOrders: 'Đơn QC ghi nhận',
  roas: 'ROAS',
  roasHint: 'Doanh thu nền tảng quảng cáo tự ghi nhận ÷ chi phí của các nền tảng có báo con số đó (Meta, Amazon). Google Ads không báo ở đây.',
  emailRev: 'Doanh thu email',
  sessions: 'Phiên truy cập',
  webConv: 'Tỷ lệ chuyển đổi web',
  storeRev: 'Doanh số cửa hàng',
  storeMoM: 'Doanh số so tháng trước',
  storeLy: 'Doanh số so năm trước',
  mer: 'Doanh số / chi phí',
  merHint: 'Doanh số cửa hàng ÷ chi phí quảng cáo cùng thị trường (MER). Tính mọi đơn bán, không chỉ đơn quảng cáo ghi nhận.',
  noteMkt: 'Doanh số cửa hàng là các cửa hàng online (Shopify). Doanh thu QC ghi nhận là số Meta và Amazon quy cho quảng cáo của họ — hai số không cộng vào nhau.',
};

const zh = {
  reportInventory: '库存页面',
  reportMarketing: '营销页面',
  reportPole: '框架库存页面',
  poleTitle: '框架类产品 — 当前状况',
  poleSubPage: '快照 {{d}} · {{m}} 月末库存，自 {{f}} 起的入库与销售（销售截至 {{s}}），从 SAP 和 NetSuite 读取的当前库存，按预计月份列出的未到货 PO。',
  poleBase: '基准 {{m}}',
  poleEmpty: '尚无当前状况快照 — Global Pole Inventory 每天早上生成。',
  poleReceived: '此后入库',
  poleToGroup: '调往其他 Helinox 法人',
  poleOther: '其他变动',
  poleMosTile: '库存月数 · 含 PO',
  poleNote: '其他变动 = 入库与销售无法解释的部分（Costco 2-pack、调整、调拨）。HINC 不含为 HUSA / HEMA / HPAC 商品下的工厂 PO（{{q}} pcs）— 已计入这些法人自己的 PO。库存月数 = 库存 ÷ 截至 {{m}} 三个月的月均销售；低于 2 会标出。',
  family: '系列',
  chStock: '各法人库存与未到货 PO',
  chPoMonth: '按预计月份的未到货 PO',
  chTopFam: '当前库存前 12 个系列',
  chMos: '各法人库存月数',
  secPoleFamily: '按法人和系列',
  secPoleByFam: '按系列（各法人对比）',
  poOverdue: '逾期',
  poNoDate: '无日期',
  expandAll: '全部展开',
  collapseAll: '全部收起',
  exportXlsx: '导出 Excel',
  exportHtml: '导出 HTML',
  shareLink: '分享链接',
  shareTitle: 'HTML 链接 — 始终为最新快照',
  shareSub: '无需登录门户即可打开此页面。始终显示最新的早间快照，并可在页面上选择其他日期。',
  shareWarn: '持有链接的任何人都能看到其中所有数据（按法人和系列的数量，不含价格）。仅限公司内部发送。替换链接可使旧链接失效。',
  noLink: '尚无链接。',
  makeLink: '生成链接',
  replaceLink: '替换链接',
  switchOff: '关闭链接',
  copy: '复制',
  copied: '已复制',
  open: '打开',
  close: '关闭',
  day: '快照日期',
  friday: '周五',
  vsDay: '对比 {{d}}',
  month: '月份',
  currency: '币种',
  reload: '刷新',
  loading: '加载中…',
  noData: '此选择没有数据。',
  total: '合计',
  invTitle: '库存页面',
  invSub: '{{d}} 的在库库存（六个法人均已载入），以 USD 计，对比 {{p}}。快照是存量：不同日期不相加。',
  secEntity: '按法人',
  secCategory: '按品类',
  secOldest: '长期库存 — 超过 1 年金额前 20 个 SKU',
  secPole: '框架 — 当前状况',
  poleSub: '快照 {{d}} · 以 {{m}} 月末库存加上此后的入库、减去销售',
  entity: '法人',
  category: '品类',
  notClassified: '尚未分类',
  qty: '数量',
  usd: '金额 (USD)',
  chgUsd: '较上周 Δ',
  chgPct: 'Δ %',
  share: '% 占比',
  transitQty: '在途数量',
  transitUsd: '在途 (USD)',
  b90: '< 90 天',
  b180: '90–180 天',
  b365: '180 天–1 年',
  b1y: '超过 1 年',
  over1yPct: '超过 1 年 %',
  skus: 'SKU 数',
  avgAge: '平均库龄（天）',
  sku: 'SKU',
  product: '产品',
  color: '颜色',
  endQty: '{{m}} 月末',
  nowQty: '当前库存',
  sold: '此后销售',
  avgMonth: '月均销售',
  mos: '库存月数',
  openPo: '未到货 PO',
  mosPo: '含 PO 月数',
  mktTitle: '营销页面',
  mktSub: '{{m}}，{{c}}{{through}} · 对比相同天数的 {{p}} 与 {{ly}}',
  through: '，截至 {{d}}',
  secMarket: '按市场',
  secPlatform: '按平台',
  secCampaign: '花费最多的广告活动 — 前 20',
  market: '市场',
  channel: '渠道',
  platform: '平台',
  campaign: '广告活动',
  spend: '广告花费',
  spendMoM: '花费较上月',
  impressions: '展示',
  clicks: '点击',
  ctr: 'CTR',
  cpc: 'CPC',
  cpm: 'CPM',
  attrRev: '广告归因收入',
  attrOrders: '广告归因订单',
  roas: 'ROAS',
  roasHint: '广告平台自报的收入 ÷ 报告该收入的平台（Meta、Amazon）的花费。Google Ads 在此不报告。',
  emailRev: '邮件收入',
  sessions: '会话',
  webConv: '网站转化率',
  storeRev: '店铺销售',
  storeMoM: '销售较上月',
  storeLy: '销售较去年',
  mer: '销售 / 花费',
  merHint: '同一市场的店铺销售 ÷ 广告花费（营销效率比）。计入全部销售，而不仅是广告归因的部分。',
  noteMkt: '店铺销售指线上店铺（Shopify）。广告归因收入是 Meta 与 Amazon 归给自身广告的收入 — 两者不相加。',
};

const dictionary = { ns: 'xBiz', en, ko, vi, zh };
export default dictionary;
